import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";

const MenuItem = ({ pageTitle,alias, routeAlias, pageLink,clickable,subItems, active }) => {
  const xprops = useSelector(state => state);
  return(
    <li className={`menuitem ${active === true ? "menuLiSelected" : ""}`}>
      {
        clickable === true ?
         <Link to={`${xprops.project.language.routes[routeAlias]}`} className={`menuLinkItem ${active === true ? "menuSelected" : ""}`}>
              {xprops.project.language.keywords[alias]}
        </Link> :
         <Link to="#" className={`menuLinkItem ${active === true ? "menuSelected" : ""}`} rel="noreferrer">
              {xprops.project.language.keywords[alias]}
        </Link>
      }
      {
        clickable === false && subItems.length > 0 &&
        <div className="dropdown-content">
          {
            subItems.map((e,i) => <Link key={i} to={`${xprops.project.language.routes[e.routeAlias]}`}>{xprops.project.language.keywords[e.alias]}</Link>)
          }
        </div>          
      }      

    </li>
  );
};

export default MenuItem;